/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GameEventData,
    GameEventDataFromJSON,
    GameEventDataFromJSONTyped,
    GameEventDataToJSON,
    GetGameEventDataResponseAllOf,
    GetGameEventDataResponseAllOfFromJSON,
    GetGameEventDataResponseAllOfFromJSONTyped,
    GetGameEventDataResponseAllOfToJSON,
    PaginatedResponse,
    PaginatedResponseFromJSON,
    PaginatedResponseFromJSONTyped,
    PaginatedResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetGameEventDataResponse
 */
export interface GetGameEventDataResponse extends PaginatedResponse {
    /**
     * 
     * @type {Array<GameEventData>}
     * @memberof GetGameEventDataResponse
     */
    eventDumps?: Array<GameEventData>;
}

export function GetGameEventDataResponseFromJSON(json: any): GetGameEventDataResponse {
    return GetGameEventDataResponseFromJSONTyped(json, false);
}

export function GetGameEventDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGameEventDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PaginatedResponseFromJSONTyped(json, ignoreDiscriminator),
        'eventDumps': !exists(json, 'eventDumps') ? undefined : ((json['eventDumps'] as Array<any>).map(GameEventDataFromJSON)),
    };
}

export function GetGameEventDataResponseToJSON(value?: GetGameEventDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PaginatedResponseToJSON(value),
        'eventDumps': value.eventDumps === undefined ? undefined : ((value.eventDumps as Array<any>).map(GameEventDataToJSON)),
    };
}


